import React, { useState, useContext, useEffect } from "react";
import globalComp from "../../../../global/components";
import imageTools from ".";
import path from "path";
import { ProductContext, ImageContext } from "../../provider";
import { AppContext } from "../../../../provider/AppProvider";

interface ImageUploaderProps {
  number: number;
  description?: JSX.Element;
}

function ImageUploader({
  number,
  description,
}: ImageUploaderProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;

  const { facebookResponseData: frd } = useContext(AppContext);
  const { productType } = useContext(ProductContext);
  const { selectedUploadType, setSelectedUploadType } = useContext(
    ImageContext
  );

  useEffect(() => {
    if (frd == null && selectedUploadType != null) {
      setSelectedUploadType("device");
    }
  }, [frd]);

  /**
   * @method handleUploadType
   * @param type {"device" | "facebook" | "instagram"} Upload type
   * @returns {void}
   * @description state handle for the upload type selected by user.
   */
  function handleUploadType(type: "device" | "facebook" | "instagram"): void {
    if (type == selectedUploadType) {
      setSelectedUploadType(null);
    } else {
      setSelectedUploadType(type);
    }
  }

  return (
    <>
      <globalComp.FieldHeader
        number={number}
        title={
          productType == "text-logo"
            ? t.upload_your_image
            : t.upload_your_images
        }
        tooltipStr={
          productType == "text-logo"
            ? t.upload_your_image_tooltip
            : t.upload_your_images_tooltip
        }
        extraCssClass={"pb-1"}
        clearAfter={true}
        element={description}
      />

      <div className={"d-flex flex-column mb-3"}>
        <div className={"d-flex justify-content-center align-items-center"}>
          {/* Device Upload Type */}
          <button
            onClick={() => {
              handleUploadType("device");
            }}
            className={"btn product-canvas__btn-wide mb-2"}
            type={"button"}>
            <img
              src={path.resolve(`${window.basePath}/images/upload.svg`)}
              alt={""}
            />
            <p>{t.device}</p>
          </button>
          {/* End Device Upload Type */}
          {/* Facebook Upload Type */}
          {/* <imageTools.FBLoginBtn
            onClick={() => {
              handleUploadType("facebook");
            }}
          /> */}
          {/* End Facebook Upload Type */}
          {/* Instagram Upload Type */}
          {/* <imageTools.IGLoginBtn
            onClick={() => {
              handleUploadType("instagram");
            }}
          /> */}
          {/* End Instagram Upload Type */}
        </div>

        <div
          className={`d-flex fade-up ${
            selectedUploadType == "facebook" ? "active" : ""
          }`}>
          <div className={"flex-grow-1 mb-2"} id={"upload-type-facebook"}>
            {/* Facebook content is injected here */}
            {selectedUploadType == "facebook" && <imageTools.FBImages />}
          </div>
        </div>

        <div
          className={`d-flex fade-up ${
            selectedUploadType == "instagram" ? "active" : ""
          }`}>
          <div className={"flex-grow-1 mb-2"} id={"upload-type-instagram"}>
            {/* Instagram content is injected here */}
            {selectedUploadType == "instagram" && <imageTools.IGImages />}
          </div>
        </div>

        <div
          className={`d-flex fade-up ${selectedUploadType ? "active" : ""}`}
          style={{ overflow: "visible" }}>
          <div className={"flex-grow-1"}>
            <form className="dropzone" id="image-upload-dropzone" />
          </div>
        </div>
      </div>
    </>
  );
}

export default ImageUploader;
